// removed by extract-text-webpack-plugin
module.exports = {"root":"_1ei9E"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Events/pages/Show/Resources/style.sass
// module id = ./src/modules/Events/pages/Show/Resources/style.sass
// module chunks = 6